import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/user/focus-on.png'
import _imports_1 from '@/assets/image/icon/close.png'


const _withScopeId = n => (_pushScopeId("data-v-80bd512a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "focus-on",
  src: _imports_0
}, null, -1))

import { ref, onActivated } from 'vue'
import { Overlay } from 'vant'
import { getUserIsSubscribe } from '@/api/home'
import Storage from '@/utils/Storage'


export default /*#__PURE__*/_defineComponent({
  __name: 'FocusOnCode',
  setup(__props) {

const isFocusOn = ref(false)

onActivated(async () => {
  fetchUserIsSubscribe()
})

const fetchUserIsSubscribe = async () => {
  isFocusOn.value = Storage.get('IS_FOCUS_ON')
  const { ret } = await getUserIsSubscribe()
  if (ret === 100) {
    isFocusOn.value = false
  } else {
    isFocusOn.value = true
  }
  Storage.set('IS_FOCUS_ON', isFocusOn.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Overlay), {
    class: "van-overlay",
    show: isFocusOn.value
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("img", {
        class: "focus-on-close-btn",
        src: _imports_1,
        alt: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isFocusOn.value = false))
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})